import { ICommonState, IReducerAction } from 'src/libraries/thunk.library';
import services from 'src/services/admin.service';
import { IAdmin, IAdminRole } from 'src/models/admin.model';

export const actionTypes = {
  ADMIN_DATA_FETCH: 'ADMIN_DATA_FETCH',
  ADMIN_LIST_FETCH: 'ADMIN_LIST_FETCH',
  ADMIN_DATA_CREATE: 'ADMIN_DATA_CREATE',
  ADMIN_DATA_UPDATE: 'ADMIN_DATA_UPDATE',
  ADMIN_DATA_DELETE: 'ADMIN_DATA_DELETE',
} as const;

// This is where we put the actions that have promise/async payload like HTTP request
export const asyncActions = {
  dataGET: {
    type: actionTypes.ADMIN_DATA_FETCH,
    service: services.dataGET,
    meta: { error: false },
  },
  listGET: {
    type: actionTypes.ADMIN_LIST_FETCH,
    service: services.listGET,
  },
  createPOST: {
    type: actionTypes.ADMIN_DATA_CREATE,
    service: services.createPOST,
    meta: { error: false },
  },
  updatePUT: {
    type: actionTypes.ADMIN_DATA_UPDATE,
    service: services.updatePUT,
    meta: { error: false },
  },
  dataDELETE: {
    type: actionTypes.ADMIN_DATA_DELETE,
    service: services.dataDELETE,
  },
};

export type IAdminAsync = typeof asyncActions;
export interface IAdminState extends ICommonState<IAdminAsync> {
  data?: IAdmin;
  list: IAdminRole[];
  total: number;
}

export const defaultState: IAdminState = {
  status: {},
  list: [],
  total: 0,
};

const AdminReducer = (
  state: IAdminState = defaultState,
  action: IReducerAction<IAdminAsync>
): IAdminState => {
  switch (action.type) {
    case actionTypes.ADMIN_DATA_FETCH: {
      return {
        ...state,
        data: action.payload,
      };
    }

    case actionTypes.ADMIN_LIST_FETCH: {
      return {
        ...state,
        list: action.payload?.rows ?? [],
        total: action.payload?.count ?? 0,
      };
    }

    default: {
      return state;
    }
  }
};

export default AdminReducer;
